import { render, staticRenderFns } from "./gnrl_magnify.vue?vue&type=template&id=4290e4f0&scoped=true"
import script from "./gnrl_magnify.vue?vue&type=script&lang=js"
export * from "./gnrl_magnify.vue?vue&type=script&lang=js"
import style0 from "./gnrl_magnify.vue?vue&type=style&index=0&id=4290e4f0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4290e4f0",
  null
  
)

export default component.exports